// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2pWMR","header":"ClearentDisclaimer_header__3wN7V","inner":"ClearentDisclaimer_inner__1iku4"};